import STEPS from "../../../pages/ScheduleProcess/enum";

export type StatusVariant = "info" | "warning" | "success" | "neutral";

export type StatusUI = {
  step: STEPS;
  label: string;
  variant: StatusVariant;
};

const STATUS_TO_STEP: Partial<Record<string, STEPS>> = {
  SCHEDULE_DONE: STEPS.SCHEDULE_DONE,
  OFFER_DONE: STEPS.OFFER_DONE,
  DOCUMENTS_TO_ANALYSIS: STEPS.DOCUMENTS_TO_ANALYSIS,
  CONTRACT_DONE: STEPS.CONTRACT_DONE,
  CONTRACT_FINISHED: STEPS.CONTRACT_FINISHED,
};

const STEP_UI = {
  [STEPS.SCHEDULE_DONE]: {
    label: "Enviar documentos",
    variant: "warning",
  },

  [STEPS.OFFER_DONE]: {
    label: "Enviar documentos",
    variant: "warning",
  },

  [STEPS.DOCUMENTS_TO_ANALYSIS]: {
    label: "Documentação em análise",
    variant: "info",
  },

  [STEPS.CONTRACT_DONE]: {
    label: "Documentação aprovada",
    variant: "success",
  },

  [STEPS.CONTRACT_FINISHED]: {
    label: "Documentação aprovada",
    variant: "success",
  },
} satisfies Record<STEPS, { label: string; variant: StatusVariant }>;

export function resolveRentProcessStatus(status?: string): StatusUI {
  const step: STEPS = STATUS_TO_STEP[status ?? ""] ?? STEPS.SCHEDULE_DONE;
  const ui = STEP_UI[step];

  return {
    step,
    label: ui.label,
    variant: ui.variant,
  };
}
